import styled from "styled-components";

export const SectionAchievementsOur = styled.section(({ theme }) => ({
    padding: "0 16px 60px 16px",
    gap: "12px",
    display: "flex",
    flexDirection: "column",

    [theme.breakpoint.xl()]: {
        padding: "0 112px 80px 112px"
    },
}))

export const CardAchievementsOur = styled.div(({ theme }) => ({
    width: "244px",
    padding: "12px 0 0 0",

    [theme.breakpoint.lg()]: {
        width: "384px",
        padding: "40px 0 8px 0"
    },
}))

export const ImageCardAchievementsOur = styled.img(({ theme }) => ({
    borderRadius: "8px 8px 0px 0px",
    width: "244px",

    [theme.breakpoint.lg()]: {
        width: "384px",
    },
}))

export const ContentCardAchievementsOur = styled.div(({ colorBackground }) => ({
    display: "flex",
    padding: "12px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "12px",
    alignSelf: "stretch",
    background: colorBackground,
    borderRadius: "0px 0px 8px 8px",
    marginTop: -10
}))

export const TitleCardAchievementsOur = styled.h3(({ theme }) => ({
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "150%",
    margin: 0,
    color: theme.color.neutral["08"],
    
    [theme.breakpoint.lg()]: {
        fontSize: "24px",
    },
}))

export const ParagraphCardAchievementsOur = styled.p(({ theme }) => ({
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "150%",
    margin: 0,
    color: theme.color.neutral["08"],

    [theme.breakpoint.lg()]: {
        fontSize: "18px",
    },
}))

export const TitleAchievementsOur = styled.h2(({ theme }) => ({
    color: theme.color.neutral["02"],
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: "150%",
    margin: 0,

    [theme.breakpoint.lg()]: {
        fontSize: "32px",
    },
}))

export const ParagraphAchievementsOur = styled.p(({ theme }) => ({
    fontSize: "18px",
    fontWeight: 500,
    color: theme.color.neutral["02"],
    lineHeight: "160%",
    margin: 0,

    [theme.breakpoint.lg()]: {
        fontSize: "20px",
    },
}))